import React, { Component, lazy } from "react";
import LinkWithSpanAndI from "../components/linkwithspanAndI";
import { companyConfigSingle } from '../actions';
import { routehelp } from "../Routehelper";
import { connect } from 'react-redux';
import { isPermission } from "../helpers/functions";
const Loader = lazy(() => import('../components/loader'));

// import { Link } from "react-router-dom";

let openSideView = [
  { name: "masters", value: false },
  { name: "users", value: false },
  { name: "expense", value: false },
  { name: "retailers", value: false }
];

class Sidebar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      webFeature: {
        stockHistory: false,
        advanceApproval: false,
        agency: false,
        beat: false,
        brand: false,
        categoriesRetailers: false,
        categoryExpense: false,
        customers: false,
        dashboard: false,
        discountMaster: false,
        dispatchDetails: false,
        ecatalogue: false,
        expenseApprovalExpense: false,
        indirectCustomers: false,
        order: false,
        orderRetailers: false,
        outstanding: false,
        product: false,
        region: false,
        routePlanning: false,
        scheme: false,
        srASM: false,
        stock: false,
        subCategoryExpense: false,
        territory: false,
        transporter: false,
        trending: false,
        uom: false,
        userHierarchy: false,
        userRetailers: false,
        users: false,
        zone: false,
        orderFailed: false,
        commissionRange: false
      },
      sideBarList: [
        {
          to: routehelp.maindashboard,
          classi: "fa tai-ico-Dashboard",
          name: "Dashboard",
          match: "dashboard",
          isChild: false
        },
        {
          parentName: "Masters",
          isChild: true,
          Child: [{
            to: routehelp.zonemanagement,
            classi: "fa tai-ico-zone",
            match: "zone",
            name: "Zone"
          },
          {
            to: routehelp.Regionmanagement,
            classi: "fa tai-ico-Region",
            match: "region",
            name: "Region"
          },
          {
            to: routehelp.Territorymanagement,
            classi: "fa tai-ico-Territory",
            match: "territory",
            name: "Territory"
          },
          {
            to: routehelp.Beatsmanagement,
            classi: "fa tai-ico-beat",
            name: "Beat",
            match: "beat",
          }]
        },
        {
          parentName: "Users",
          isChild: true,
          Child: [
            {
              to: routehelp.usermanagement,
              classi: "fa tai-ico-Users-Customers",
              name: "User",
              match: "users",
            },
            {
              to: routehelp.customermanagement,
              classi: "fa tai-ico-Customer",
              name: "Customer",
              match: "customers",
            },
            {
              to: routehelp.indirectcustomer,
              classi: "fa fa-user-secret",
              name: "Indirect Customers",
              match: "indirectCustomers"
            },

            {
              to: routehelp.SrAsmAssignment,
              classi: "fa tai-ico-Assignment",
              name: "Sr. ASM-Users Assignment",
              match: "srASM"
            },
            {
              to: routehelp.userHierarchyList,
              classi: "fa fa-solid fa-tree",
              name: "User Hierarchy",
              match: "userHierarchy",
            },
          ]
        },
        {
          to: routehelp.Brandmanagement,
          classi: "fa fa-bullhorn",
          name: "Brand",
          match: "brand"
        },
        {
          to: routehelp.productmanagement,
          classi: "fa tai-ico-Product",
          name: "Product",
          match: "product"
        },
        {
          to: routehelp.uomMaster,
          classi: "fa tai-ico-Product",
          name: "UOM",
          match: "uom"
        },

        {
          to: routehelp.stockmanagement,
          classi: "fa tai-ico-Stock",
          name: "Stock",
          match: "stock"
        },
        {
          to: routehelp.agencyMaster,
          classi: "fa tai-ico-Agency",
          name: "Agency",
          match: "agency"
        },
        {
          to: routehelp.transporter,
          classi: "fa tai-ico-Transporter",
          name: "Transporter",
          match: "transporter"
        },
        {
          to: routehelp.schememanagement,
          classi: "fa tai-ico-Scheme",
          name: "Scheme",
          match: "scheme"
        },
        {
          to: routehelp.outstanding,
          classi: "fa tai-ico-Outstanding",
          name: "Outstanding",
          match: "outstanding"
        },
        {
          to: routehelp.dispatchDetails,
          classi: "fa tai-ico-Dispatch-Details",
          name: "Dispatch Details",
          match: "dispatchDetails"
        },
        {
          to: routehelp.orderTemplateList,
          classi: "fa tai-ico-Order",
          name: "Order Template",
          match: "orderTemplate"
        },
        {
          to: routehelp.orderCatalogueList,
          classi: "fa tai-ico-Order",
          name: "Orders Catalouge",
          match: "orderCatalogue"
        },
        {
          to: routehelp.ordermanagement,
          classi: "fa tai-ico-Order",
          name: "Order",
          match: "order"
        },
        {
          to: routehelp.routeplanning,
          classi: "fa tai-ico-Route-Planning",
          name: "Route Planning",
          match: "routePlanning"
        },
        {
          parentName: "Expense",
          isChild: true,
          Child: [
            {
              to: routehelp.allowanceCatagory,
              classi: "fa tai-ico-Category",
              name: "Category",
              match: "categoryExpense"
            },
            {
              to: routehelp.allowanceSubCatagory,
              classi: "fa tai-ico-sub-Categories",
              name: "Sub Category",
              match: "subCategoryExpense"
            },
            {
              to: routehelp.expenseApproval,
              classi: "fa tai-ico-Expense-Approval",
              name: "Expense Approval",
              match: "expenseApprovalExpense"
            }
          ]
        },
        {
          to: routehelp.advanceApproval,
          classi: "fa tai-ico-Advance-Approval",
          name: "Advance Approval",
          match: "advanceApproval"
        },
        {
          parentName: "Retailers",
          isChild: true,
          Child: [
            {
              to: routehelp.retail,
              classi: "fa tai-ico-Users-Customers",
              name: "Retailer Users",
              match: "userRetailers"
            },
            {
              to: routehelp.trending,
              classi: "fa tai-ico-Trendings",
              name: "What's Trending",
              match: "trending"
            },
            {
              to: routehelp.catagory,
              classi: "fa tai-ico-sub-Categories",
              name: "Categories",
              match: "categoriesRetailers"
            },
            {
              to: routehelp.eCatalogue,
              classi: "fa tai-ico-E-Catalogue",
              name: "E-catalogue",
              match: "ecatalogue"
            },
            {
              to: routehelp.retailerOrdermanagement,
              classi: "fa tai-ico-Order",
              name: "Retailer's Order",
              match: "orderRetailers"
            }
          ]
        },
        {
          to: routehelp.discountMaster,
          classi: "fa fa-truck",
          name: "Discount Master",
          match: "discountMaster"
        },
        {
          to: routehelp.commissionList,
          classi: "fa fa-list",
          name: "Commission Management",
          match: "commission",
          isChild: false
        },
        {
          to: routehelp.commissionRange,
          classi: "fa fa-percent",
          name: "Commission Range",
          match: "commissionRange",
          isChild: false
        },
        {
          to: routehelp.orderFailed,
          classi: "fa fa-exclamation-triangle",
          name: "Order Failed List",
          match: "orderFailed",
          isChild: false
        },
        {
          to: routehelp.payment,
          classi: "fa fa-money",
          name: "Payments",
          match: "payment",
          isChild: false
        },
        {
          to: routehelp.feedback,
          classi: "fa fa-comments-o",
          name: "Feedback",
          match: "feedback",
          isChild: false
        }
      ],
    }
  }

  showMenu(val) {
    openSideView.forEach((item) => {
      if (item.name === val) {
        item.value = !item.value
      } else {
        item.value = false
      }
    })
    this.forceUpdate();
  }

  componentWillUnmount() {
    //all sub dropdown will be closed
    openSideView.forEach((item) => {
      item.value = false;
    });
    this.forceUpdate();
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    this.props.companyConfigSingle({});
  }


  shouldComponentUpdate(nextProps) {
    if (nextProps !== this.props) {
      this.setState({
        isLoading: false
      });

      if (nextProps.companyConfigSingle_res && nextProps.companyConfigSingle_res.success === true) {
        // nextProps.companyConfigSingle_res.success = null;
        if (nextProps.companyConfigSingle_res.item) {
          this.setState({
            webFeature: nextProps.companyConfigSingle_res.item.webFeature
          });
        }
      }

    }
    return true;
  }


  render() {
    return (
      <div className="left-sidebar">
        {
          this.state.isLoading ? <Loader /> :
            <nav className="sidebar-menu scrollbarcustom">
              <ul id="nav-accordion">

                {/* {console.log(this.state.webFeature)} */}
                {/* loop */}

                {
                  this.state.sideBarList.map((ele, index) => {
                    // { console.log(this.state.webFeature[ele.match], ele.match, ele.isChild) }
                    if (!ele.isChild) {
                      return (
                        this.state.webFeature && this.state.webFeature[ele.match] && isPermission(ele.match, "list") ?
                          <div key={index} title={ele.name}>
                            <LinkWithSpanAndI
                              to={ele.to}
                              classi={ele.classi}
                              aria-hidden="true"
                              name={ele.name}
                            />
                          </div> : null
                      )
                    } else {
                      let isDisplayParent = 0;
                      ele.Child.forEach((child) => {
                        // console.log(child.match, this.state.webFeature[child.match]);
                        if (this.state.webFeature && this.state.webFeature[child.match] && isPermission(child.match, "list")) {
                          isDisplayParent++;
                        }
                      })
                      // console.log(ele.parentName, isDisplayParent, "================");
                      return (
                        isDisplayParent > 0 ? <li className="sidebar-item" key={index}>
                          <div className="sidenav-link" id={"submenu-" + index} key={index} onClick={() => this.showMenu(ele.parentName.toLowerCase())} >
                            <i className="fa tai-ico-Masters" aria-hidden="true"></i>
                            <span>{ele.parentName}</span>
                            <i className={openSideView.filter((e) => e.name === ele.parentName.toLowerCase())[0].value ? "fa fa-angle-up" : "fa fa-angle-down"} style={{ float: 'right' }} aria-hidden="true"></i>
                          </div>
                          {/* {console.log(openSideView.filter((e) => e.name === ele.parentName.toLowerCase())[0].value)} */}
                          {
                            openSideView.filter((e) => e.name === ele.parentName.toLowerCase())[0].value && (
                              <ul className="treeview-menu">
                                {
                                  ele.Child.map((child, cindex) => {
                                    return (
                                      isPermission(child.match, "list") &&
                                      <div title={child.name} key={cindex}>
                                        {
                                          this.state.webFeature && this.state.webFeature[child.match] ?
                                            <LinkWithSpanAndI
                                              to={child.to}
                                              classi={child.classi}
                                              aria-hidden="true"
                                              name={child.name}
                                            /> : null
                                        }
                                      </div>
                                    )
                                  })
                                }
                              </ul>
                            )}
                        </li> : null
                      )
                    }
                  })
                }

                {/* commented */}

                {/* <LinkWithSpanAndI
              to={routehelp.maindashboard}
              classi="fa tai-ico-Dashboard "
              name="Dashboard"
            /> */}

                {/* <LinkWithSpanAndI
              to={routehelp.mis}
              classi="fa tai-ico-MIS-Report"
              name="MIS Report"
            /> */}

                {/* <li className="sidebar-item">

              <div className="sidenav-link" id="master" onClick={() => this.showMenu("master")} >
                <i className="fa tai-ico-Masters" aria-hidden="true"></i>
                <span>Masters</span>
                <i className={openSideView[0].value ? "fa fa-angle-up" : "fa fa-angle-down"} style={{ float: 'right' }} aria-hidden="true"></i>
              </div>

              {openSideView[0].value && (
                <ul className="treeview-menu">

                  <LinkWithSpanAndI
                    to={routehelp.zonemanagement}
                    classi="fa tai-ico-zone"
                    aria-hidden="true"
                    name="Zone"
                  />

                  <LinkWithSpanAndI
                    to={routehelp.Regionmanagement}
                    classi="fa tai-ico-Region"
                    name="Region"
                  />

                  <LinkWithSpanAndI
                    to={routehelp.Territorymanagement}
                    classi="fa tai-ico-Territory"
                    name="Territory"
                  />

                  <LinkWithSpanAndI
                    to={routehelp.Beatsmanagement}
                    classi="fa tai-ico-beat"
                    name="Beat"
                  />
                </ul>
              )}
            </li> */}

                {/* <li className="sidebar-item">

              <div className="sidenav-link" id="usercustomer" onClick={() => this.showMenu("userAndCustomer")} >
                <i className="fa tai-ico-Users-Customers" aria-hidden="true"></i>
                <span>Users & Customers</span>
                <i className={openSideView[1].value ? "fa fa-angle-up" : "fa fa-angle-down"} style={{ float: 'right' }} aria-hidden="true"></i>
              </div>

              {openSideView[1].value && (
                <ul className="treeview-menu">

                  <LinkWithSpanAndI
                    to={routehelp.usermanagement}
                    classi="fa tai-ico-Users-Customers"
                    name="User"
                  />

                  <LinkWithSpanAndI
                    to={routehelp.customermanagement}
                    classi="fa tai-ico-Customer"
                    name="Customer"
                  />

                  <LinkWithSpanAndI
                    to={routehelp.indirectcustomer}
                    classi="fa fa-user-secret"
                    name="Indirect Customers "
                  />

                  <LinkWithSpanAndI
                    to={routehelp.SrAsmAssignment}
                    classi="fa tai-ico-Assignment"
                    name="Sr. ASM-Users Assignment"
                  />

                  <LinkWithSpanAndI
                    to={routehelp.userHierarchyList}
                    classi="fa fa-solid fa-tree"
                    name="User Hierarchy"
                  />

                </ul>)}
            </li> */}

                {/* <LinkWithSpanAndI
              to={routehelp.Brandmanagement}
              classi="fa fa-bullhorn"
              name="Brand"
            />

            <LinkWithSpanAndI
              to={routehelp.productmanagement}
              classi="fa tai-ico-Product"
              name="Product"
            />

            <LinkWithSpanAndI
              to={routehelp.uomMaster}
              classi="fa tai-ico-Product"
              name="UOM"
            />

            <LinkWithSpanAndI
              to={routehelp.stockmanagement}
              classi="fa tai-ico-Stock"
              name="Stock"
            />

            <LinkWithSpanAndI
              to={routehelp.agencyMaster}
              classi="fa tai-ico-Agency"
              name="Agency"
            />

            <LinkWithSpanAndI
              to={routehelp.transporter}
              classi="fa tai-ico-Transporter"
              name="Transporter"
            />

            <LinkWithSpanAndI
              to={routehelp.schememanagement}
              classi="fa tai-ico-Scheme"
              name="Scheme"
            />

            <LinkWithSpanAndI
              to={routehelp.outstanding}
              classi="fa tai-ico-Outstanding"
              name="Outstanding"
            />

            <LinkWithSpanAndI
              to={routehelp.dispatchDetails}
              classi="fa tai-ico-Dispatch-Details"
              name="Dispatch Details"
            /> */}

                {/* <LinkWithSpanAndI
              to={routehelp.ordermanagement}
              classi="fa tai-ico-Order"
              name="Order"
            />

            <LinkWithSpanAndI
              to={routehelp.routeplanning}
              classi="fa tai-ico-Route-Planning"
              name="Route Planning"
            /> */}

                {/* <li className="sidebar-item">

              <div className="sidenav-link" id="expenses" onClick={() => this.showMenu("expense")}>
                <i className="fa tai-ico-Expense" aria-hidden="true"></i>
                <span>Expense</span>
                <i className={openSideView[2].value ? "fa fa-angle-up" : "fa fa-angle-down"} style={{ float: 'right' }} aria-hidden="true"></i>
              </div>

              {openSideView[2].value && (
                <ul className="treeview-menu">

                  <LinkWithSpanAndI
                    to={routehelp.allowanceCatagory}
                    classi="fa tai-ico-Category"
                    name="Category"
                  />

                  <LinkWithSpanAndI
                    to={routehelp.allowanceSubCatagory}
                    classi="fa tai-ico-sub-Categories"
                    name="Sub Category"
                  />

                  <LinkWithSpanAndI
                    to={routehelp.expenseApproval}
                    classi="fa tai-ico-Expense-Approval"
                    name="Expense Approval"
                  />

                </ul>)}
            </li> */}

                {/* <LinkWithSpanAndI
              to={routehelp.advanceApproval}
              classi="fa tai-ico-Advance-Approval"
              name="Advance Approval"
            /> */}

                {/* <LinkWithSpanAndI
              to={routehelp.discountMaster}
              classi="fa fa-truck"
              name="Discount Master"
            /> */}

                {/* <LinkWithSpanAndI to="" classi="ti-user" name="User role management" /> */}
                {/* <LinkWithSpanAndI
              to={routehelp.touringVoucher}
              classi="fa fa-map"
              name="Touring Voucher"
            /> */}

                {/* <li className="sidebar-item">
              <div className="sidenav-link" id="retailers" onClick={() => this.showMenu("retailers")}>
                <i className="fa tai-ico-Retailers" aria-hidden="true"></i>
                <span>Retailers</span>
                <i className={openSideView[3].value ? "fa fa-angle-up" : "fa fa-angle-down"} style={{ float: 'right' }} aria-hidden="true"></i>
              </div>

              {openSideView[3].value && (
                <ul className="treeview-menu">

                  <LinkWithSpanAndI
                    to={routehelp.retail}
                    classi="fa tai-ico-Users-Customers"
                    name="User"
                  />

                  <LinkWithSpanAndI
                  to={routehelp.discountMaster}
                  classi="fa fa-truck"
                  name="Discount Master"
                />

                  <LinkWithSpanAndI
                    to={routehelp.trending}
                    classi="fa tai-ico-Trendings"
                    name="What's Trending"
                  />

                  <LinkWithSpanAndI
                    to={routehelp.catagory}
                    classi="fa tai-ico-sub-Categories"
                    name="Categories"
                  />

                  <LinkWithSpanAndI
                    to={routehelp.eCatalogue}
                    classi="fa tai-ico-E-Catalogue"
                    name="E-catalogue"
                  />

                  <LinkWithSpanAndI
                    to={routehelp.retailerOrdermanagement}
                    classi="fa tai-ico-Order"
                    name="Retailer's Order"
                  />

                </ul>)}
            </li> */}

                {/* <LinkWithSpanAndI
                to={routehelp.logs}
                classi="fa tai-ico-info"
                name="Logs"
            /> */}

                {/* <LinkWithSpanAndI to={routehelp.RateMapping} classi="fa fa-truck" name="Rate Mapping" /> */}
              </ul>
            </nav>
        }

      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    companyConfigSingle_res: state.companyConfigSingle_res
  };
}

const mapDispatchToProps = dispatch => ({
  companyConfigSingle: data => dispatch(companyConfigSingle(data))
});

Sidebar = connect(
  mapStateToProps,
  mapDispatchToProps
)(Sidebar);

export default Sidebar;